// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Kpi$ReactHooksTemplate = require("./kpi.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var DomainModel$ReactHooksTemplate = require("./domainModel.res.js");

function fieldId(t) {
  return t.fieldId;
}

function name(t) {
  return t.name;
}

function decode(json) {
  return {
          fieldId: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json)
        };
}

var KpiFields = {
  fieldId: fieldId,
  name: name,
  emptyFields: /* [] */0,
  decode: decode
};

function userId(t) {
  return t.userId;
}

function email(t) {
  return t.email;
}

function decode$1(json) {
  return {
          userId: Json_decode.field("id", Json_decode.$$int, json),
          email: Json_decode.field("email", Json_decode.string, json)
        };
}

var KpiUser = {
  userId: userId,
  email: email,
  emptyUsers: /* [] */0,
  decode: decode$1
};

function KpiCrud(props) {
  var toggleModal = props.toggleModal;
  var action = props.action;
  var kpi = props.kpi;
  var handleChange = props.handleChange;
  var match = React.useState(function (param) {
        return Kpi$ReactHooksTemplate.emptyKpi();
      });
  var setFormKpi = match[1];
  var formKpi = match[0];
  var match$1 = React.useState(function (param) {
        return /* [] */0;
      });
  var setUsers = match$1[1];
  var match$2 = React.useState(function (param) {
        return /* [] */0;
      });
  var setFields = match$2[1];
  var match$3 = React.useState(function (param) {
        return /* [] */0;
      });
  var setValues = match$3[1];
  React.useEffect((function (param) {
          if (kpi !== undefined) {
            Curry._1(setFormKpi, (function (param) {
                    return kpi;
                  }));
            var filterFieldId = Kpi$ReactHooksTemplate.filterFieldId(kpi);
            Js_promise.then_((function (values) {
                    return Promise.resolve(Curry._1(setValues, (function (param) {
                                      return values;
                                    })));
                  }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/kpis/field_values?field_id=" + filterFieldId, (function (param) {
                        return Json_decode.field("field_values", (function (param) {
                                      return Json_decode.list(Json_decode.string, param);
                                    }), param);
                      })));
            Curry._1(setValues, (function (param) {
                    return {
                            hd: Kpi$ReactHooksTemplate.filterValue(kpi),
                            tl: /* [] */0
                          };
                  }));
          } else {
            Curry._1(setFormKpi, (function (param) {
                    return Kpi$ReactHooksTemplate.emptyKpi();
                  }));
          }
          Js_promise.then_((function (users) {
                  return Promise.resolve(Curry._1(setUsers, (function (param) {
                                    return users;
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/kpis/users", (function (param) {
                      return Json_decode.field("users", (function (param) {
                                    return Json_decode.list(decode$1, param);
                                  }), param);
                    })));
          Js_promise.then_((function (fields) {
                  return Promise.resolve((console.log(fields), Curry._1(setFields, (function (param) {
                                      return fields;
                                    }))));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/kpis/kpi_fields", (function (param) {
                      return Json_decode.field("fields", (function (param) {
                                    return Json_decode.list(decode, param);
                                  }), param);
                    })));
        }), []);
  var handleEmailChange = function ($$event) {
    var email = Utils$ReactHooksTemplate.formTargetValue($$event);
    console.log(email);
    Curry._1(setFormKpi, (function (formKpi) {
            return {
                    id: formKpi.id,
                    userId: formKpi.userId,
                    email: email,
                    filterFieldId: formKpi.filterFieldId,
                    filterField: formKpi.filterField,
                    filterValue: formKpi.filterValue,
                    kpiValue: formKpi.kpiValue
                  };
          }));
  };
  var handleFieldChange = function ($$event) {
    var filterFieldId = Utils$ReactHooksTemplate.formTargetValue($$event);
    Js_promise.then_((function (values) {
            return Promise.resolve(Curry._1(setValues, (function (param) {
                              return values;
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/kpis/field_values?field_id=" + filterFieldId, (function (param) {
                return Json_decode.field("field_values", (function (param) {
                              return Json_decode.list(Json_decode.string, param);
                            }), param);
              })));
    Curry._1(setFormKpi, (function (formKpi) {
            return {
                    id: formKpi.id,
                    userId: formKpi.userId,
                    email: formKpi.email,
                    filterFieldId: filterFieldId,
                    filterField: formKpi.filterField,
                    filterValue: formKpi.filterValue,
                    kpiValue: formKpi.kpiValue
                  };
          }));
  };
  var handleValueChange = function ($$event) {
    var filterValue = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setFormKpi, (function (formKpi) {
            return {
                    id: formKpi.id,
                    userId: formKpi.userId,
                    email: formKpi.email,
                    filterFieldId: formKpi.filterFieldId,
                    filterField: formKpi.filterField,
                    filterValue: filterValue,
                    kpiValue: formKpi.kpiValue
                  };
          }));
  };
  var handleKpiChange = function ($$event) {
    var kpiValue = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setFormKpi, (function (formKpi) {
            return {
                    id: formKpi.id,
                    userId: formKpi.userId,
                    email: formKpi.email,
                    filterFieldId: formKpi.filterFieldId,
                    filterField: formKpi.filterField,
                    filterValue: formKpi.filterValue,
                    kpiValue: kpiValue
                  };
          }));
  };
  var tmp;
  switch (action) {
    case "create" :
        tmp = JsxRuntime.jsx("div", {
              children: "New Kpi"
            });
        break;
    case "delete" :
        tmp = JsxRuntime.jsx("div", {
              children: "Delete Kpi"
            });
        break;
    case "edit" :
        tmp = JsxRuntime.jsx("div", {
              children: "Edit Kpi"
            });
        break;
    default:
      tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  var tmp$1;
  var exit = 0;
  switch (action) {
    case "delete" :
        tmp$1 = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Email",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                    disabled: true,
                                    type: "text",
                                    value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Kpi$ReactHooksTemplate.email(formKpi))
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mt-30-px mb-30-px"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Field",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                    disabled: true,
                                    type: "text",
                                    value: Kpi$ReactHooksTemplate.filterField(formKpi)
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Value",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                    disabled: true,
                                    type: "text",
                                    value: Kpi$ReactHooksTemplate.filterValue(formKpi)
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "KPI",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                    disabled: true,
                                    type: "text",
                                    value: String(Kpi$ReactHooksTemplate.kpiValue(formKpi))
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px"
                    })
              ]
            });
        break;
    case "create" :
    case "edit" :
        exit = 1;
        break;
    default:
      tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  if (exit === 1) {
    var tmp$2 = action === "edit" ? JsxRuntime.jsx("input", {
            className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
            disabled: true,
            type: "text",
            value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Kpi$ReactHooksTemplate.email(formKpi))
          }) : JsxRuntime.jsxs("select", {
            children: [
              JsxRuntime.jsx("option", {
                    children: "Select Email",
                    disabled: true,
                    value: "Select Email"
                  }, "0"),
              $$Array.of_list(Belt_List.map(match$1[0], (function (user) {
                          return JsxRuntime.jsx("option", {
                                      children: user.email,
                                      disabled: action === "edit",
                                      value: String(user.userId)
                                    }, String(user.userId));
                        })))
            ],
            className: "block border px-3 py-2 border-gray-400 cursor-pointer\n                                   w-3/5 bg-white rounded capitalize mr-6 text-sm",
            id: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Kpi$ReactHooksTemplate.email(formKpi)),
            placeholder: "Select Email",
            value: Caml_obj.equal(Kpi$ReactHooksTemplate.email(formKpi), Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.empty, undefined)) ? "Select Email" : Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Kpi$ReactHooksTemplate.email(formKpi)),
            onChange: handleEmailChange
          });
    var tmp$3 = action === "edit" ? JsxRuntime.jsx("input", {
            className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
            disabled: true,
            type: "text",
            value: Kpi$ReactHooksTemplate.filterField(formKpi)
          }) : JsxRuntime.jsxs("select", {
            children: [
              JsxRuntime.jsx("option", {
                    children: "Select Field",
                    disabled: true,
                    value: "Select Field"
                  }, "0"),
              $$Array.of_list(Belt_List.map(match$2[0], (function (field) {
                          return JsxRuntime.jsx("option", {
                                      children: field.name,
                                      value: String(field.fieldId)
                                    }, String(field.fieldId));
                        })))
            ],
            className: "block border px-3 py-2 border-gray-400 cursor-pointer\n                                  w-3/5 bg-white rounded capitalize mr-6 text-sm",
            value: Kpi$ReactHooksTemplate.filterFieldId(formKpi) === "" ? "Select Field" : Kpi$ReactHooksTemplate.filterFieldId(formKpi),
            onChange: handleFieldChange
          });
    var tmp$4 = action === "edit" ? JsxRuntime.jsx("input", {
            className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
            disabled: true,
            type: "text",
            value: Kpi$ReactHooksTemplate.filterValue(formKpi)
          }) : JsxRuntime.jsxs("select", {
            children: [
              JsxRuntime.jsx("option", {
                    children: "Select Value",
                    disabled: true,
                    value: "Select Value"
                  }, "00"),
              $$Array.of_list(Belt_List.mapWithIndex(match$3[0], (function (id, value) {
                          return JsxRuntime.jsx("option", {
                                      children: value,
                                      value: value
                                    }, String(id + 1 | 0));
                        })))
            ],
            className: "block border px-3 py-2 border-gray-400 cursor-pointer\n                                  w-3/5 bg-white rounded capitalize mr-6 text-sm",
            value: Kpi$ReactHooksTemplate.filterValue(formKpi) === "" ? "Select Value" : Kpi$ReactHooksTemplate.filterValue(formKpi),
            onChange: handleValueChange
          });
    tmp$1 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Email",
                                className: "text-sm font-medium w-1/5"
                              }),
                          tmp$2
                        ],
                        className: "flex gap-1 items-center w-full"
                      }),
                  className: "flex mt-30-px mb-30-px items-center"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Field",
                                className: "text-sm font-medium w-1/5"
                              }),
                          tmp$3
                        ],
                        className: "flex gap-1 items-center w-full"
                      }),
                  className: "flex mb-30-px items-center"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Value",
                                className: "text-sm font-medium w-1/5"
                              }),
                          tmp$4
                        ],
                        className: "flex gap-1 items-center w-full"
                      }),
                  className: "flex mb-30-px items-center"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "KPI",
                                className: "text-sm font-medium w-1/5"
                              }),
                          JsxRuntime.jsx("input", {
                                className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                type: "text",
                                value: String(Kpi$ReactHooksTemplate.kpiValue(formKpi)),
                                onChange: handleKpiChange
                              })
                        ],
                        className: "flex gap-1 items-center w-full"
                      }),
                  className: "flex mb-30-px items-center"
                })
          ]
        });
  }
  var tmp$5 = action === "delete" ? "Delete" : "Save";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              tmp,
                              JsxRuntime.jsx("img", {
                                    className: "h-14-px float-right cursor-pointer ",
                                    src: Image$ReactHooksTemplate.closeIcon,
                                    onClick: toggleModal
                                  })
                            ],
                            className: "p-8 text-lg font-bold flex justify-between border-b border-gray-200"
                          }),
                      JsxRuntime.jsx("div", {
                            children: tmp$1,
                            className: "h-full text-base p-8"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Discard",
                                    className: "bg-ghostwhite border border-gray-400\n          flex rounded py-3 px-6 text-xs",
                                    id: "close_modal",
                                    onClick: toggleModal
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "border border-gray-400\n            flex rounded py-3 px-6 text-xs text-white cursor-pointer " + (
                                      action === "delete" ? "bg-deepcarminepink" : "bg-palatinateblue"
                                    ),
                                    type: "submit",
                                    value: tmp$5,
                                    onClick: (function (param) {
                                        Curry._2(handleChange, formKpi, action);
                                      })
                                  })
                            ],
                            className: "p-8 flex gap-3 justify-end border-t border-gray-200"
                          })
                    ],
                    className: "flex flex-col justify-between h-full"
                  }),
              className: "bg-white modal-campaign z-10 shadow relative border border-gray-300 pointer-events-auto"
            });
}

var make = KpiCrud;

exports.KpiFields = KpiFields;
exports.KpiUser = KpiUser;
exports.make = make;
/* react Not a pure module */
